import { PrintType } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned, fetchFromApiSignedIfAdmin } from './fetchFromApi';

export const fetchPrintTypes = () => {
  const params = { fullData: true };

  const request = getParams().useGlobalInventoryData
    ? fetchFromApiSigned<{ printTypes: PrintType[] }>('printTypes', params)
    : fetchFromApiSignedIfAdmin<{ printTypes: PrintType[] }>(
        `${getParams().context}s/${getParams().contextId}/printTypes`,
        params
      );

  return request.then((data) => data.printTypes);
};
